import { usePropertyCurrentDebt } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { MoneyBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { formatCurrencyOrUndefined } from '@apply/ui';

interface CurrentDebtProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const CurrentDebt: React.FC<CurrentDebtProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const [currentDebt, set_currentDebt] = usePropertyCurrentDebt(propertyGuid);
    const label = 'Current debt on property (enter $0 if you owe no debt)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(currentDebt ?? 0)}
                />
            ) : (
                <>
                    <div
                        className='pageSubHeader'
                        style={{ paddingTop: '25px' }}
                    >
                        Existing debt on property?
                    </div>
                    <MoneyBox
                        id='currentDebt'
                        allowNegative={false}
                        value={currentDebt}
                        onChange={(value) => {
                            set_currentDebt(value || 0);
                        }}
                        required={required}
                        label={label}
                        displayChange={false}
                    />
                </>
            )}
        </>
    );
};
